import {
  FETCH_ASSETS,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILURE,
  RESET_FETCH_ASSETS
} from "./assetsTypes";

export const fetchAssets = () => {
    return {
      type: FETCH_ASSETS
    };
}

export const fetchAssetsSuccess = (response) => {
    return {
        type: FETCH_ASSETS_SUCCESS,
        payload: response
    }
}

export const fetchAssetsFAILURE = (error) => {
  return {
    type: FETCH_ASSETS_FAILURE,
    payload: error,
  };
};


export const resetAssets = () => {
  return {
    type: RESET_FETCH_ASSETS
  };
}